import React, { useEffect, useState } from "react";
import environment from "lib/environment";
import Session from "lib/session";
import ErrorView from "../components/error-view";
import useAnalytics from 'lib/use-analytics';

const errorUrl = environment.get().error_url;

const ErrorContainer = () => {
  let [error, setError] = useState({});
  const { track } = useAnalytics();

  useEffect(() => {
    const rawError = JSON.parse(Session.getItem("last_error")) || {};
    const loadedError = { status: rawError.status, data: rawError.data };
    setError(loadedError);
    track('Error Page Viewed', {
      statusCode: rawError.status,
      errorId: rawError.data?.id,
    });
  }, []);

  const handleAccountLinkClick = () => {
    track('Error Page Account Link Clicked', { statusCode: error.status });
  };

  return <ErrorView errorUrl={errorUrl} error={error} onAccountLinkClick={handleAccountLinkClick} />;
};
export default ErrorContainer;
